import { useEffect, useState } from "react";
import { Container, FormControlLabel, Grid, Switch } from "@material-ui/core";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import AddIcon from "@material-ui/icons/Add";
import { useHistory } from "react-router";

import HeaderModule from "../../../components/header/HeaderModule";
import Btn from "../../../components/buttons/Btn";
import TextField from "../../../components/basics/TextFieldErp";
import RedBall from "../../../assets/imgs/bolinha-vermelha.png";
import GreenBall from "../../../assets/imgs/bolinha-verde.png";
import BigDataTable from "../../../components/tables/BigDataTable";
import SpeedDialErp from "../../../components/speeddial/SpeedDialErp";
import { BallContainer } from "../../prouser/transportadoras/styles/Transportadora";
import { Margin } from "../../../theme/styles/Utils";
import { GlobalVariables } from "../../../GlobalVariables";

let typingTimer = null;
const ClassificacaoServicoListagem = () => {
  const [textFilter, setTextFilter] = useState("");
  const [showOnlyActives, setShowOnlyActives] = useState(true);
  const [queryOrWhere, setQueryOrWhere] = useState(null);
  const [queryWhere, setQueryWhere] = useState({ ativo: "" });

  const { push } = useHistory();

  const columns = [
    {
      disabled: true,
      id: "acoes",
      label: "Ações",
      align: "center",
      format: (item) => (
        <SpeedDialErp
          actions={[
            {
              icon: <EditOutlinedIcon />,
              name: "Editar",
              action: () => push("cadastro", { id: item.id }),
            },
          ]}
        />
      ),
    },
    {
      id: "id",
      label: "ID",
    },
    {
      id: "descricao",
      label: "Descrição",
      style: { minWidth: 275 },
    },
    {
      id: "tiposervico",
      label: "Tipo Serviço",
    },
    {
      id: "ativo",
      label: "Ativo",
      align: "center",
      format: (value) =>
        value.ativo === "S" ? (
          <BallContainer>
            <img src={GreenBall} alt="ativo" />
          </BallContainer>
        ) : (
          <BallContainer>
            <img src={RedBall} alt="inativo" />
          </BallContainer>
        ),
    },
  ];

  useEffect(() => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(() => {
      setQueryOrWhere({
        descricao: encodeURIComponent(`${textFilter}`),
      });
    }, 1500);
  }, [textFilter]);

  useEffect(() => {
    setQueryWhere({ ativo: showOnlyActives ? "S" : "N" });
  }, [showOnlyActives]);

  return (
    <>
      <HeaderModule
        title="CADASTRO DE CLASSIFICAÇÃO DE SERVIÇOS"
        videoId={GlobalVariables.screenVideosIds.cadastroClassificacaoContratos}
      />
      <Margin top="100" />
      <Container maxWidth="xl">
        <Grid container spacing={3}>
          <Grid
            item
            container
            justifyContent="space-between"
            alignItems="flex-end"
          >
            <Grid item xs={12} sm={12} md={7}>
              <TextField
                value={textFilter}
                setValue={setTextFilter}
                label="Busque por Descrição"
                variant="filled"
              />
            </Grid>

            <Grid item xs={6} sm={6} md={3} lg={3}>
              <FormControlLabel
                control={
                  <Switch
                    checked={showOnlyActives}
                    onChange={() => setShowOnlyActives((current) => !current)}
                    color="primary"
                  />
                }
                label="Ativos"
                labelPlacement="end"
              />
            </Grid>

            <Grid item flex={1}>
              <Btn
                label="Novo"
                startIcon={<AddIcon />}
                onClick={() => push("cadastro")}
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <BigDataTable
              tableTitle=""
              route="faturamento/contratoservicos/v1"
              //   fields={{
              //     "faturamento.tipocontratos":
              //       "id,descricao,codigo_servico_municipio,cnae,codigo_ibpt,ativo",
              //   }}
              columns={columns}
              where={queryWhere}
              orWhere={queryOrWhere}
              reload={false}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default ClassificacaoServicoListagem;
